import { css, cx } from "@linaria/core"
import { observer } from "mobx-react-lite"
import { useMemo } from "react"

import type { DiffFile } from "@/components/DiffView/DiffView.tsx"
import type { ReactNode } from "react"


function calculateLineChanges(files: DiffFile[]) {
  let additions = 0
  let deletions = 0

  for (const file of files) {
    if (file.diff && file.diff.className === "InlineDiff") {
      for (const line of file.diff.lines) {
        if (line.type === "ADDED") {
          additions++
        } else if (line.type === "DELETED") {
          deletions++
        }
      }
    }
  }

  return { additions, deletions }
}

export const ChangeStats = observer(({ files, isActive, isHovered = false }: {
  files: DiffFile[]
  isActive: boolean
  isHovered?: boolean
}) => {
  const { additions, deletions } = useMemo(() => {
    return calculateLineChanges(files)
  }, [files])

  if (additions === 0 && deletions === 0) {
    return null
  }

  const parts = []

  if (additions > 0) {
    parts.push(
      <span key="additions" className={cx(Changes, isActive || isHovered ? Additions : null)}>
        +{additions}
      </span>
    )
  }

  if (deletions > 0) {
    parts.push(
      <span key="deletions" className={cx(Changes, isActive || isHovered ? Deletions : null)}>
        −{deletions}
      </span>
    )
  }

  return (
    <span>
      {" "}
      {parts.reduce((acc, part, index) => {
        if (index === 0) return [part]
        return [...acc, " ", part]
      }, [] as ReactNode[])}
    </span>
  )
})

const Changes = css`
  color: var(--secondary-text-color);
  font-weight: 600;
`

const Additions = css`
  color: oklch(68.6% 0.233 142.441deg);
`

const Deletions = css`
  color: oklch(67.1% 0.178 23.193deg);
`
